import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FieldSet from '../../../../../../components/Modules/FieldSet';
import Selector from '../../../../../../components/Modules/Selector';
import DateFilter from '../../../../../../components/Modules/DateFilter';
import courtsMapper from '../../../courtsMapper';
import './civil.less';


class Civil extends Component {
  regionOptions = courtsMapper('district', 'District Court')

  render() {
    const {
      region,
      caseType,
      natureOfSuit,
      dateFrom,
      dateTo,
      cause,
      jurisdiction,
      caseFlag,
      caseProperties,
      select,
      multiselect,
    } = this.props;

    return (
      <div className="reports-tab-form reports-tab-forms-civil">
        <FieldSet title="Case Information">
          <div className="row no-padding">
            <Selector
              multi
              clearable={false}
              className="reports-tab-civil-region-selector"
              options={this.regionOptions}
              title="Region"
              value={region}
              placeholder="Select Region"
              onChange={multiselect.bind(this, 'region')} />
            <Selector
              multi
              clearable={false}
              className="reports-tab-civil-case-type-selector"
              options={caseTypeOptions}
              title="Case Type"
              value={caseType}
              placeholder="Any"
              onChange={multiselect.bind(this, 'caseType')} />
          </div>
          <div className="row">
            <DateFilter
              from={dateFrom}
              to={dateTo}
              onChangeFrom={select.bind(this, 'dateFrom')}
              onChangeTo={select.bind(this, 'dateTo')}
              className="reports-tab-civil-date-filter-selector" />
          </div>
          <div className="row">
            <Selector
              multi
              clearable={false}
              className="reports-tab-civil-nature-of-suit-selector"
              options={natureOfSuitOptions}
              title="Nature of Suit"
              value={natureOfSuit}
              placeholder=""
              onChange={multiselect.bind(this, 'natureOfSuit')} />
          </div>
        </FieldSet>
        <FieldSet title="Advanced Filters">
          <div className="row no-padding">
            <Selector
              multi
              clearable={false}
              className="reports-tab-civil-cause-selector"
              options={causeOptions}
              title="Cause"
              value={cause}
              placeholder=""
              onChange={multiselect.bind(this, 'cause')} />
            <Selector
              multi
              clearable={false}
              className="reports-tab-civil-jurisdiction-selector"
              options={jurisdictionOptions}
              title="Jurisdiction"
              value={jurisdiction}
              placeholder=""
              onChange={multiselect.bind(this, 'jurisdiction')} />
          </div>
          <div className="row">
            <Selector
              multi
              clearable={false}
              className="reports-tab-civil-case-flag-selector"
              options={caseFlagOptions}
              title="Case Flag"
              value={caseFlag}
              placeholder=""
              onChange={multiselect.bind(this, 'caseFlag')} />
            <Selector
              multi
              clearable={false}
              className="reports-tab-civil-case-properties-selector"
              options={casePropertiesOptions}
              title="Case Properties"
              value={caseProperties}
              placeholder=""
              onChange={multiselect.bind(this, 'caseProperties')} />
          </div>
        </FieldSet>
      </div>
    );
  }
}

Civil.propTypes = {
  region: PropTypes.any.isRequired,
  caseType: PropTypes.any.isRequired,
  natureOfSuit: PropTypes.any.isRequired,
  dateFrom: PropTypes.any.isRequired,
  dateTo: PropTypes.any.isRequired,
  cause: PropTypes.any.isRequired,
  jurisdiction: PropTypes.any.isRequired,
  caseFlag: PropTypes.any.isRequired,
  caseProperties: PropTypes.any.isRequired,
  setFormValue: PropTypes.func.isRequired,
  select: PropTypes.func.isRequired,
  multiselect: PropTypes.func.isRequired,
};


function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(Civil);


const caseTypeOptions = {
  cv: 'Civil',
  mc: 'Miscellaneous',
  md: 'Multidistrict Litigation',
};

const natureOfSuitOptions = {
  0: '0 (zero)',
  110: '110 (Insurance)',
  120: '120 (Contract: Marine)',
  130: '130 (Miller Act)',
  140: '140 (Negotiable Instrument)',
  150: '150 (Contract: Recovery/E...)',
  151: '151 (Contract: Recovery M...)',
  152: '152 (Contract: Recovery S...)',
  153: '153 (Contract: Recovery V...)',
  160: '160 (Stockholders Suits)',
  190: '190 (Contract: Other)',
  195: '195 (Contract Product Lia...)',
  196: '196 (Contract: Franchise)',
  210: '210 (Condemnation)',
  220: '220 (Real Property: Forec...)',
  230: '230 (Rent Lease & Ejectment)',
  240: '240 (Torts to Land)',
  245: '245 (Tort Product Liability)',
  290: '290 (Real Property: Other)',
  310: '310 (Airplane)',
  315: '315 (Airplane Product Lia...)',
  320: '320 (Assault Libel & Slander)',
  330: '330 (Federal Employer\'s L...)',
  340: '340 (Marine)',
  345: '345 (Marine Product Liabi...)',
  350: '350 (Motor Vehicle)',
  355: '355 (Motor Vehicle Prod. ...)',
  360: '360 (P.I.: Other)',
  362: '362 (Personal Inj. Med. M...)',
  365: '365 (Personal Inj. Prod. ...)',
  368: '368 (P.I. : Asbestos)',
  370: '370 (Fraud or Truth-In-Le...)',
  371: '371 (Truth in Lending)',
  380: '380 (Personal Property: O...)',
  385: '385 (Prop. Damage Prod. L...)',
  400: '400 (State Reapportionment)',
  410: '410 (Anti-Trust)',
  422: '422 (Bankruptcy Appeal (801))',
  423: '423 (Bankruptcy Withdrawl)',
  430: '430 (Banks and Banking)',
  440: '440 (Civil Rights: Other)',
  441: '441 (Civil Rights: Voting)',
  442: '442 (Civil Rights: Jobs)',
  443: '443 (Civil Rights: Accomm...)',
  444: '444 (Civil Rights: Welfare)',
  445: '445 (Civil Rights: Americ...)',
  446: '446 (Civil Rights: Americ...)',
  450: '450 (Commerce ICC Rates, ...)',
  460: '460 (Deportation)',
  462: '462 (Naturalization Appli...)',
  463: '463 (Habeas Corpus - Alie...)',
  465: '465 (Other Immigration Ac...)',
  470: '470 (Racketeer/Corrupt Or...)',
  480: '480 (Consumer Credit)',
  490: '490 (Cable/Satellite TV)',
  510: '510 (Prisoner: Vacate Sen...)',
  530: '530 (Habeas Corpus (General))',
  535: '535 (Death Penalty - Habe...)',
  540: '540 (Mandamus & Other)',
  550: '550 (Prisoner: Civil Rights)',
  555: '555 (Habeas Corpus (Priso...)',
  610: '610 (Forfeit/Penalty: Agr...)',
  620: '620 (Forfeit/Penalty: Foo...)',
  625: '625 (Drug Related Seizure...)',
  630: '630 (Forfeit/Penalty: Liq...)',
  640: '640 (Forfeit/Penalty: R.R...)',
  650: '650 (Forfeit/Penalty: Air...)',
  660: '660 (Forfeit/Penalty: Occ...)',
  690: '690 (Forfeit/Penalty: Other)',
  710: '710 (Labor: Fair Standards)',
  720: '720 (Labor: Labor/Mgt. Re...)',
  730: '730 (Labor: Reporting/Dis...)',
  740: '740 (Labor: Railway Labor...)',
  790: '790 (Labor: Other)',
  791: '791 (Labor: E.R.I.S.A.)',
  810: '810 (Selective Service)',
  820: '820 (Copyright)',
  830: '830 (Patent)',
  840: '840 (Trademark)',
  850: '850 (Securities/Commodities)',
  861: '861 (Social Security: HIA)',
  862: '862 (Social Security: Bla...)',
  863: '863 (Social Security: DIW...)',
  864: '864 (Social Security: SSI...)',
  865: '865 (Social Security: RSI...)',
  870: '870 (Taxes)',
  871: '871 (Tax Suits: IRS-Third...)',
  875: '875 (Taxes: Customer Chal...)',
  890: '890 (Other Statutory Actions)',
  891: '891 (Agriculture Acts)',
  892: '892 (Economic Stabilizati...)',
  893: '893 (Environmental Matters)',
  894: '894 (Energy Allocation Act)',
  895: '895 (Freedom of Informati...)',
  900: '900 (Appeal of Fee Determ...)',
  950: '950 (Constitutional - Sta...)',
};

const causeOptions = {
  0: '0 (No cause code entered)',
  '02:0431': '02:0431 (02:431 Fed. Election...)',
  '02:0437': '02:0437 (02:437 Federal Elect...)',
  '05:0075': '05:0075 (05:75(2) Contract - ...)',
  '05:0551': '05:0551 (05:551 Administrativ...)',
  '05:0552fi': '05:0552fi (05:552 Freedom of In...)',
  '05:0552pa': '05:0552pa (05:552 Right to Priv...)',
  '05:0554': '05:0554 (05:0554 Constitution...)',
  '05:0701': '05:0701 (05:0701 Maritime Sub...)',
  '05:0702': '05:0702 (05:702 Administrativ...)',
  '05:0704': '05:0704 (05:704 Labor Litigation)',
  '05:7703': '05:7703 (05:7703 Discriminati...)',
  '05:8470': '05:8470 (05:8470 Enforcement ...)',
  '07:0006': '07:0006 (7:6(b) Federal Commo...)',
  '07:0025': '07:0025 (7:25 Fraud - Commodi...)',
  '07:0181': '07:0181 (07:181 Packers & Sto...)',
  '07:0499': '07:0499 (07:499 Agricultural ...)',
  '07:0601': '07:0601 (07:601 USDA Condemna...)',
  '07:2023': '07:2023 (07:2023 Violation of...)',
  '07:2321': '07:2321 (07:2321 Plant Variet...)',
  '08:1105': '08:1105 (8:1105(a) Aliens: Ha...)',
  '08:1182': '08:1182 (8:1182 Defend. Denia...)',
  '08:1252': '08:1252 (08:1252(a)(2) Injunc...)',
  '08:1260': '08:1260 (08:1260 Aliens: Acce...)',
  '08:1324': '08:1324 (08:1324 Aliens: Comp...)',
  '08:1329': '08:1329 (08:1329 Writ of Mand...)',
  '08:1446': '08:1446 (8:1446 Petition for ...)',
  '08:1451(j)': '08:1451(j) (8:1451(j) Motion to ...)',
  '09:0001': '09:0001 (09:1 U.S. Arbitratio...)',
  '09:0009': '09:0009 (9:9 Motion to Confir...)',
  '09:0010': '09:0010 (09:0010 Petition to ...)',
  '10:1408': '10:1408 (10:1408 Claim for Mi...)',
  '10:1552': '10:1552 (10:1552 Armed Forces...)',
  '10:1553': '10:1553 (10:1553 Armed Forces...)',
  '10:2305': '10:2305 (10:2305 Review of Fe...)',
  '11:0101': '11:0101 (11:101 Bankruptcy)',
  '12:0022': '12:0022 (12:22 Securities Fraud)',
  '12:0635': '12:0635 (12:635 Breach of Ins...)',
  '12:1461': '12:1461 (12:1461 Homeowners L...)',
  '12:1464': '12:1464 (12:1464 Federal Savi...)',
  '12:1703': '12:1703 (12:1703 Default of H...)',
  '12:1725': '12:1725 (12:1725 Collection u...)',
  '12:1730': '12:1730 (12:1730  Collection ...)',
  '12:1819': '12:1819 (12:1819 Default of P...)',
  '12:1821': '12:1821 (12:1821 Default of L...)',
  '12:191': '12:191 (12:191 Bank Foreclosure)',
  '12:192': '12:192 (12:192 Liquidation o...)',
  '12:1971': '12:1971 (12:1971 Relief under...)',
  '12:1972': '12:1972 (12:1972 Typing Arran...)',
  '12:2601': '12:2601 (Real Estate Settleme...)',
  '12:3410': '12:3410 (12:3410 Right to Fin...)',
  '15:0001': '15:0001 (15:1 Antitrust Litig...)',
  '15:0002at': '15:0002at (15:2 Antitrust Litig...)',
  '15:0002fl': '15:0002fl (15:2(a) Fair Labor S...)',
  '15:0005': '15:0005 (15:5(a) Fair Labor S...)',
  '15:0015': '15:0015 (15:15 Antitrust Liti...)',
  '15:0025': '15:0025 (15:25 Clayton Act)',
  '15:0044': '15:0044 (15:44 Trademark Infr...)',
  '15:0045': '15:0045 (15:0045 Federal Trad...)',
  '15:0052': '15:0052 (15:0052  Federal Tra...)',
  '15:0053': '15:0053 (15:0053  Federal Tra...)',
  '15:0077': '15:0077 (15:77 Securities Fraud)',
  '15:0078': '15:0078 (15:78m(a) Securities...)',
  '15:0631': '15:0631 (15:631 Small Busines...)',
  '15:0717': '15:0717 (15:717 Natural Gas Act)',
  '15:0754': '15:0754 (15:754 Emergency Pet...)',
  '15:1051': '15:1051 (15:1051 Trademark In...)',
  '15:1114': '15:1114 (15:1114 Trademark In...)',
  '15:1121': '15:1121 (15:1121 Trademark In...)',
  '15:1125': '15:1125 (15:1125 Trademark In...)',
  '15:1126': '15:1126 (15:1126 Patent Infri...)',
  '15:1127': '15:1127 (15:1127 Trademark In...)',
  '15:1601': '15:1601 (15:1601 Truth in Len...)',
  '15:1640': '15:1640 (15:1640 Truth in Len...)',
  '15:1681': '15:1681 (15:1681 Fair Credit ...)',
  '15:1692': '15:1692 (15:1692 Fair Debt Co...)',
  '15:1938': '15:1938 (15:1938 Fair Labor S...)',
  '15:1981': '15:1981 (15:1981 Fraud-Motor ...)',
  '15:1988': '15:1988 (15:1988 Fraud-Motor ...)',
  '15:1989': '15:1989 (15:1989 Fraud-Motor ...)',
  '15:2301': '15:2301 (15:2301 Magnuson-Mos...)',
  '15:2801': '15:2801 (15:2801 Petroleum Ma...)',
  '15:53(b)': '15:53(b) (15:53(b) - Prelim & ...)',
  '16:0668': '16:0668 (16:668 Bald Eagle Pr...)',
  '16:0703': '16:0703 (16:703 Migratory Bir...)',
  '16:1538': '16:1538 (16:1538  Endangered ...)',
  '16:3371': '16:3371 (16:3371  Wildlife Un...)',
  '16:3372': '16:3372 (16:3372 Conservation...)',
  '16:3373': '16:3373 (16:3373  Appeal of D...)',
  '16:3374': '16:3374 (16:3374 Conservation...)',
  '17:0101': '17:0101 (17:101 Copyright Inf...)',
  '17:0501': '17:0501 (17:501 Copyright Inf...)',
  '17:0504': '17:0504 (17:504 Copyright Inf...)',
  '17:1203': '17:1203 (17:1203 Digital Mill...)',
  '18:0241': '18:0241 (18:241 Conspiracy Ag...)',
  '18:1961': '18:1961 (18:1961 Racketeering...)',
  '18:1962': '18:1962 (18:1962 Racketeering...)',
  '18:1964': '18:1964 (18:1964 Racketeering...)',
  '18:2511': '18:2511 (18:2511 Wiretapping)',
  '18:3114': '18:3114 (18:3114 Motion for R...)',
  '18:4208': '18:4208 (18:4208(B) Agency Ac...)',
  '19:1305': '19:1305 (19:1305 Custom Dutie...)',
  '20:1080': '20:1080 (20:1080 Student Loan...)',
  '20:1400': '20:1400 (20:1400 Civil Rights...)',
  '20:1401': '20:1401 (20:1401 Education: H...)',
  '21:0841': '21:0841 (21:841 Forfeiture Pr...)',
  '21:0881': '21:0881 (21:881 Forfeiture Pr...)',
  '21:0881a': '21:0881a (21:881 Forfeiture Pr...)',
  '21:0881re': '21:0881re (21:881 Forfeiture Pr...)',
  '23:0134': '23:0134 (23:134 P.I.- Auto Ne...)',
  '23:1441': '23:1441 (23:1441 Contract Rea...)',
  '24:1000': '24:1000 (24:1000 Hospitals & ...)',
  '25:0640': '25:0640 (25:640 Indian Tribal...)',
  '25:1901': '25:1901 (25:1901 Indian Child...)',
  '26:6212': '26:6212 (26:6212 Injunctive R...)',
  '26:6213': '26:6213 (26:6213 Injunctive R...)',
  '26:6502': '26:6502 (26:6502 IRS:Enforcem...)',
  '26:6532': '26:6532 (26:6532 IRS: Refund ...)',
  '26:6702': '26:6702 (26:6702 IRS: Refund ...)',
  '26:6703': '26:6703 (26:6703 IRS: Refund ...)',
  '26:7401': '26:7401 (26:7401 IRS: Tax Lia...)',
  '26:7402': '26:7402 (26:7402 IRS: Petitio...)',
  '26:7403': '26:7403 (26:7403  Suit to Enf...)',
  '26:7422rt': '26:7422rt (26:7422 IRS: Refund ...)',
  '26:7422rx': '26:7422rx (26:7422 IRS: Refund ...)',
  '26:7426': '26:7426 (26:7426 IRS: Wrongfu...)',
  '26:7429': '26:7429 (26:7429 IRS: Tax Jeo...)',
  '26:7609': '26:7609 (26:7609 IRS: Petitio...)',
  '27:0185': '27:0185 (27:185 Enforcement o...)',
  '28:0157c': '28:0157c (28:0157(c)(1) Findin...)',
  '28:0157d': '28:0157d (28:0157 Motion for W...)',
  '28:0158': '28:0158 (28:0158  Notice of A...)',
  '28:0185': '28:0185 (28:185 Suit to Compe...)',
  '28:0451': '28:0451 (28:451 Employment Di...)',
  '28:0754': '28:0754 (28:754 Receiver of P...)',
  '28:0794': '28:0794 (28:794 Rehabilitatio...)',
  '28:1001': '28:1001 (28:1001 E.R.I.S.A.)',
  '28:1132': '28:1132 (28:1132 E.R.I.S.A.)',
  '28:1330': '28:1330 (28:1330 Breach of Co...)',
  '28:1331': '28:1331 (28:1331 Fed. Question)',
  '28:1331al': '28:1331al (28:1331 Fed. Questio...)',
  '28:1331at': '28:1331at (28:1331 Fed. Questio...)',
  '28:1331au': '28:1331au (28:1331 Fed. Questio...)',
  '28:1331b': '28:1331b (28:1331  Federal Que...)',
  '28:1331bc': '28:1331bc (28:1331 Fed. Questio...)',
  '28:1331ca': '28:1331ca (28:1331 Fed Question...)',
  '28:1331cm': '28:1331cm (28:1331 Fed. Questio...)',
  '28:1331cv': '28:1331cv (28:1331 Federal Ques...)',
  '28:1331ed': '28:1331ed (28:1331 Fed. Questio...)',
  '28:1331ej': '28:1331ej (28:1331 Federal Ques...)',
  '28:1331es': '28:1331es (28:1331  Enforcement...)',
  '28:1331fl': '28:1331fl (28:1331 Fed. Questio...)',
  '28:1331in': '28:1331in (28:1331 Fed. Questio...)',
  '28:1331mm': '28:1331mm (28:1331 Fed. Questio...)',
  '28:1331ng': '28:1331ng (28:1331 Fed. Questio...)',
  '28:1331pi': '28:1331pi (28:1331 Fed. Questio...)',
  '28:1331rd': '28:1331rd (28:1331 Fed. Questio...)',
  '28:1331rp': '28:1331rp (28:1331(a) Fed. Ques...)',
  '28:1331rr': '28:1331rr (28:1331 Fed. Questio...)',
  '28:1331sv': '28:1331sv (28:1331 Fed. Questio...)',
  '28:1331tr': '28:1331tr (28:1331 Fed. Questio...)',
  '28:1331tt': '28:1331tt (28:1331 Fed. Questio...)',
  '28:1331v': '28:1331v (28:1331 Fed. Questio...)',
  '28:1331wl': '28:1331wl (28:1331  Federal Que...)',
  '28:1331wt': '28:1331wt (28:1331 Fed. Questio...)',
  '28:1332ac': '28:1332ac (28:1332 Diversity-Ac...)',
  '28:1332al': '28:1332al (28:1332 Diversity-Ai...)',
  '28:1332as': '28:1332as (28:1332 Diversity-As...)',
  '28:1332au': '28:1332au (28:1332 Diversity-Au...)',
  '28:1332bc': '28:1332bc (28:1332 Diversity-Br...)',
  '28:1332co': '28:1332co (28:1332 Diversity-Co...)',
  '28:1332ct': '28:1332ct (28:1332 Diversity-(C...)',
  '28:1332det': '28:1332det (28:1332 Diversity: F...)',
  '28:1332df': '28:1332df (28:1332 Diversity-Co...)',
  '28:1332ds': '28:1332ds (28:1332 Diversity-Co...)',
  '28:1332ed': '28:1332ed (28:1332 Diversity-Em...)',
  '28:1332fd': '28:1332fd (28:1332 Diversity-Br...)',
  '28:1332fr': '28:1332fr (28:1332 Diversity-Fraud)',
  '28:1332ia': '28:1332ia (28:1332 Diversity-In...)',
  '28:1332ij': '28:1332ij (28:1332 Diversity-In...)',
  '28:1332in': '28:1332in (28:1332 Diversity-In...)',
  '28:1332jd': '28:1332jd (28:1332 Diversity-De...)',
  '28:1332lb': '28:1332lb (28:1332 Diversity-Li...)',
  '28:1332lm': '28:1332lm (28:1332  Diversity -...)',
  '28:1332ma': '28:1332ma (28:1332  Diversity-M...)',
  '28:1332mm': '28:1332mm (28:1332 Diversity-Me...)',
  '28:1332mv': '28:1332mv (28:1332 Diversity-Mo...)',
  '28:1332ni': '28:1332ni (28:1332 Diversity-Ne...)',
  '28:1332nm': '28:1332nm (28:1332 Diversity-No...)',
  '28:1332nr': '28:1332nr (28:1332 Diversity-No...)',
  '28:1332oc': '28:1332oc (28:1332 Diversity-Ot...)',
  '28:1332pd': '28:1332pd (28:1332 Diversity-Pr...)',
  '28:1332pi': '28:1332pi (28:1332 Diversity-Pe...)',
  '28:1332pl': '28:1332pl (28:1332 Diversity-Pr...)',
  '28:1332pr': '28:1332pr (28:1332 Diversity-Pe...)',
  '28:1332qt': '28:1332qt (28:1332 Diversity-Pe...)',
  '28:1332ri': '28:1332ri (28:1332  Diversity-R...)',
  '28:1332sa': '28:1332sa (28:1332 - Diversity:...)',
  '28:1332sf': '28:1332sf (28:1332 - Diversity:...)',
  '28:1332ss': '28:1332ss (28:1332 Diversity - ...)',
  '28:1332tl': '28:1332tl (28:1332 Diversity-To...)',
  '28:1332tm': '28:1332tm (28:1332 Diversity-To...)',
  '28:1332tn': '28:1332tn (28:1332 Diversity-To...)',
  '28:1332wd': '28:1332wd (28:1332 Diversity-Wr...)',
  '28:1333': '28:1333 (28:1333 Admiralty)',
  '28:1334': '28:1334 (28:1334 Bankruptcy A...)',
  '28:1334c': '28:1334c (28:1334(c)  R&R re m...)',
  '28:1335': '28:1335 (28:1335 Interpleader...)',
  '28:1337': '28:1337 (28:1337 Sherman-Clay...)',
  '28:1338cp': '28:1338cp (28:1338 Copyright In...)',
  '28:1338pt': '28:1338pt (28:1338 Patent Infri...)',
  '28:1338tr': '28:1338tr (28:1338 Trademark In...)',
  '28:1340': '28:1340 (28:1340 IRS: Custom ...)',
  '28:1340er': '28:1340er (28:1340 Recovery of ...)',
  '28:1341': '28:1341 (28:1341 Complaint fo...)',
  '28:1343': '28:1343 (28:1343 Violation of...)',
  '28:1345': '28:1345 (28:1345 USA Plaintiff)',
  '28:1345co': '28:1345co (28:1345 Replevin & C...)',
  '28:1345db': '28:1345db (28:1345 Debt to US -...)',
  '28:1345df': '28:1345df (28:1345   Default of...)',
  '28:1345er': '28:1345er (28:1345 Recovery of ...)',
  '28:1345fc': '28:1345fc (28:1345 Foreclosure)',
  '28:1345ff': '28:1345ff (28:1345 Complaint fo...)',
  '28:1345hl': '28:1345hl (28:1345 VA Home Loan...)',
  '28:1345mc': '28:1345mc (28:1345  Medical Car...)',
  '28:1345mi': '28:1345mi (28:1345 Mining Claim...)',
  '28:1345pd': '28:1345pd (28:1345 Property Damage)',
  '28:1345pe': '28:1345pe (28:1345  Property Ej...)',
  '28:1345rc': '28:1345rc (28:1345 Recovery of ...)',
  '28:1345st': '28:1345st (28:1345 Default of S...)',
  '28:1345tp': '28:1345tp (28:1345 Trespass on ...)',
  '28:1345va': '28:1345va (28:1345 Recovery of ...)',
  '28:1346bc': '28:1346bc (28:1346  Breach of C...)',
  '28:1346rc': '28:1346rc (28:1346 Recovery of ...)',
  '28:1346tc': '28:1346tc (28:1346 Tort Claim)',
  '28:1346wd': '28:1346wd (28:1346 Wrongful Death)',
  '28:1349': '28:1349 (28:1348 Corporation ...)',
  '28:1352': '28:1352 (28:1352 Miller Act)',
  '28:1355': '28:1355 (28:1355  Petition fo...)',
  '28:1358': '28:1358 (28:1358 Land Condemn...)',
  '28:1361': '28:1361 (28:1361 Petition for...)',
  '28:1362ic': '28:1362ic (28:1362 Indian Triba...)',
  '28:1362iw': '28:1362iw (28:1362 Declaration ...)',
  '28:1364': '28:1364 (28:1364 Auto Negligence)',
  '28:1391': '28:1391 (28:1391 Personal Injury)',
  '28:1402': '28:1402 (28:1402 Medical Malp...)',
  '28:1407': '28:1407 (28:1407 Airline Crash)',
  '28:1441ac': '28:1441ac (28:1441 Petition for...)',
  '28:1441al': '28:1441al (28:1441 Petition for...)',
  '28:1441as': '28:1441as (28:1441 Petition for...)',
  '28:1441au': '28:1441au (28:1441 Petition for...)',
  '28:1441bc': '28:1441bc (28:1441 Petition for...)',
  '28:1441cv': '28:1441cv (28:1441 Petition for...)',
  '28:1441df': '28:1441df (28:1441 Petition for...)',
  '28:1441dj': '28:1441dj (28:1441 Petition for...)',
  '28:1441ds': '28:1441ds (28:1441 Petition for...)',
  '28:1441ed': '28:1441ed (28:1441  Petition fo...)',
  '28:1441fc': '28:1441fc (28:1441 Petition for...)',
  '28:1441fr': '28:1441fr (28:1441 Petition for...)',
  '28:1441ij': '28:1441ij (28:1441 Petition for...)',
  '28:1441in': '28:1441in (28:1441 Petition for...)',
  '28:1441int': '28:1441int (28:1441 Petition for...)',
  '28:1441lb': '28:1441lb (28:1441 Petition for...)',
  '28:1441lm': '28:1441lm (28:1441 Petition for...)',
  '28:1441mm': '28:1441mm (28:1441 Petition for...)',
  '28:1441ni': '28:1441ni (28:1441 Petition for...)',
  '28:1441nm': '28:1441nm (28:1441 Petition for...)',
  '28:1441nr': '28:1441nr (28:1441 Notice of Re...)',
  '28:1441oc': '28:1441oc (28:1441 Petition For...)',
  '28:1441pd': '28:1441pd (28:1441 Petition for...)',
  '28:1441pi': '28:1441pi (28:1441 Petition for...)',
  '28:1441pl': '28:1441pl (28:1441 Petition for...)',
  '28:1441pr': '28:1441pr (28:1441 Petition for...)',
  '28:1441qt': '28:1441qt (28:1441 Petition for...)',
  '28:1441ri': '28:1441ri (28:1441 Petition for...)',
  '28:1441sa': '28:1441sa (28:1441 - Petition f...)',
  '28:1441sf': '28:1441sf (28:1441 - Petition f...)',
  '28:1441tl': '28:1441tl (28:1441 Petition for...)',
  '28:1441tm': '28:1441tm (28:1441 Petition for...)',
  '28:1441tn': '28:1441tn (28:1441 Petition for...)',
  '28:1441wd': '28:1441wd (28:1441 Petition for...)',
  '28:1442bc': '28:1442bc (28:1442 Petition for...)',
  '28:1442nr': '28:1442nr (28:1442 Notice of Re...)',
  '28:1442pr': '28:1442pr (28:1442 Petition for...)',
  '28:1443': '28:1443 (28:1443(1) Rent, Lea...)',
  '28:1444': '28:1444 (28:1444 Petition for...)',
  '28:1446in': '28:1446in (28:1446 Breach of Co...)',
  '28:1446nr': '28:1446nr (28:1446 Notice of Re...)',
  '28:1446pd': '28:1446pd (28:1446 Petition for...)',
  '28:1446pi': '28:1446pi (28:1446 Petition for...)',
  '28:1446pl': '28:1446pl (28:1446pl Petition f...)',
  '28:1446pr': '28:1446pr (28:1446 Petition for...)',
  '28:1452': '28:1452 (28:1452  R&R re moti...)',
  '28:1651': '28:1651 (28:1651  Petition fo...)',
  '28:1651hc': '28:1651hc (28:1651 Petition for...)',
  '28:1651mn': '28:1651mn (28:1651 Petition for...)',
  '28:1782': '28:1782 (28:1782 Letter rogat...)',
  '28:1821': '28:1821 (28:1821 Witness Fees...)',
  '28:1983': '28:1983 (28:1983 Civil Rights)',
  '28:2201': '28:2201 (28:2201 Constitution...)',
  '28:2201dj': '28:2201dj (28:2201 Declaratory ...)',
  '28:2201ij': '28:2201ij (28:2201 Injunction)',
  '28:2201in': '28:2201in (28:2201 Declaratory ...)',
  '28:2241': '28:2241 (28:2241 Petition for...)',
  '28:2254': '28:2254 (28:2254 Petition for...)',
  '28:2254se': '28:2254se (28:2254 Ptn for Writ...)',
  '28:2255': '28:2255 (28:2255 Motion to Va...)',
  '28:2271': '28:2271 (28:2271 Federal Tort...)',
  '28:2345': '28:2345 (28:2345 Medicare Rec...)',
  '28:2409': '28:2409 (28:2409(a) Quiet Tit...)',
  '28:2410': '28:2410 (28:2410 Quiet Title)',
  '28:2671': '28:2671 (28:2671 Federal Tort...)',
  '28:2674': '28:2674 (28:2674 Federal Tort...)',
  '28:3001': '28:3001 (28:3001 Federal Debt...)',
  '28:7402': '28:7402 (28:7402 Refund of Taxes)',
  '28:7422': '28:7422 (28:7422 Appeal from ...)',
  '29:0151': '29:0151 (29:151 Labor: Review...)',
  '29:0160': '29:0160 (29:160(1) National L...)',
  '29:0184': '29:0184 (29:184 Violation Col...)',
  '29:0185ep': '29:0185ep (29:185 Employee Pens...)',
  '29:0185lm': '29:0185lm (29:185 Labor/Mgt. Re...)',
  '29:0201do': '29:0201do (29:201 Denial of Ove...)',
  '29:0201fl': '29:0201fl (29:201 Fair Labor St...)',
  '29:0203': '29:0203 (29:203 Equal Pay Act)',
  '29:0206': '29:0206 (29:206 Collect Unpai...)',
  '29:0401': '29:0401 (29:0401 Labor Manage...)',
  '29:0621': '29:0621 (29:621 Job Discrimin...)',
  '29:0623': '29:0623 (29:623 Job Discrimin...)',
  '29:0626': '29:0626 (29:626 Job Discrimin...)',
  '29:0633': '29:0633 (29:633 Job Discrimin...)',
  '29:0651': '29:0651 (29:651 Occupational ...)',
  '29:0754': '29:0754 (29:754 Discrimination)',
  '29:0791': '29:0791 (29:791 Job Discrimin...)',
  '29:0794': '29:0794 (29:0794 Job Discrimi...)',
  '29:1001': '29:1001 (29:1001 E.R.I.S.A.: ...)',
  '29:1002': '29:1002 (29:1002 E.R.I.S.A.: ...)',
  '29:1104': '29:1104 (29:1104 Recovery of ...)',
  '29:1109': '29:1109 (29:1109 Breach of Fi...)',
  '29:1131': '29:1131 (29:1131 ERISA - Coll...)',
  '29:1132': '29:1132 (29:1132 E.R.I.S.A.-E...)',
  '29:1145': '29:1145 (29:1145 E.R.I.S.A.)',
  '29:1149': '29:1149 (29:1149 Recover Pens...)',
  '29:1337': '29:1337 (29:1337 E.R.I.S.A.)',
  '29:1362': '29:1362 (29:1362  ERISA)',
  '29:1381': '29:1381 (29:1381 E.R.I.S.A.)',
  '29:1401': '29:1401 (29:1401(b)(2) Appeal...)',
  '29:1451': '29:1451 (29:1451 E.R.I.S.A.)',
  '29:1801': '29:1801 (29:1801 Farmworker R...)',
  '29:790': '29:790 (29:790  Rehabilitati...)',
  '30:0181': '30:0181 (30:181 Environment: ...)',
  '30:0801': '30:0801 (30:0801 Penalities/F...)',
  '30:1201': '30:1201 (30:1201 Environment:...)',
  '30:1202': '30:1202 (30:1202 Mining Recla...)',
  '30:1276': '30:1276 (30:1276 Interior: Re...)',
  '31:3545': '31:3545 (31:3545 Action to Re...)',
  '31:3729': '31:3729 (31:3729 False Claims...)',
  '31:3731': '31:3731 (31:3731 Fraud)',
  '33:1319cw': '33:1319cw (33:1319 Clean Water Act)',
  '33:1319pv': '33:1319pv (33:1319 Pollutants &...)',
  '33:1365': '33:1365 (33:1365 Environmenta...)',
  '35:0145': '35:0145 (35:145 Patent Infrin...)',
  '35:0183': '35:0183 (35:183 Patent Infrin...)',
  '35:0271': '35:0271 (35:271 Patent Infrin...)',
  '38:1681': '38:1681 (38:1681 Recovery of ...)',
  '38:1686': '38:1686 (38:1686 Recovery of ...)',
  '38:1780': '38:1780 (38:1780 Recovery of ...)',
  '38:2011': '38:2011 (38:2011 - Veteran\'s ...)',
  '38:2021': '38:2021 (Right to re-employme...)',
  '38:3116': '38:3116 (38:3116 VA Overpayment)',
  '38:775': '38:775 (Recovery of Servicem...)',
  '39:3005': '39:3005 (39:3005 Detention of...)',
  '39:409': '39:409 (39:409  Postal Service)',
  '40:0258': '40:0258 (40:258(a) Public Bui...)',
  '40:0270': '40:0270 (40:270 Miller Act)',
  '40:0875': '40:0875 (40:875 Public Buildi...)',
  '41:0251': '41:0251 (41:251 Public Contra...)',
  '41:1463': '41:1463 (41:1463 Public Contr...)',
  '42:0205': '42:0205 (42:205 Denial Social...)',
  '42:0206': '42:0206 (42:206 Social Securi...)',
  '42:0247': '42:0247 (42:247 Personal Inju...)',
  '42:0402': '42:0402 (42:402 Social Securi...)',
  '42:0405id': '42:0405id (42:405 Review of HHS...)',
  '42:0405wc': '42:0405wc (42:405 Review of HHS...)',
  '42:0405ww': '42:0405ww (42:405 Review of HHS...)',
  '42:0416': '42:0416 (42:416 Denial of Soc...)',
  '42:0427': '42:0427 (42:427 Social Securi...)',
  '42:11603': '42:11603 (International Child ...)',
  '42:12101': '42:12101 (42:12101 Americans W...)',
  '42:1383': '42:1383 (42:1383 Review of HH...)',
  '42:1395': '42:1395 (42:1395  HHS: Advers...)',
  '42:1396': '42:1396 (42:1396 - Tort Negli...)',
  '42:1471': '42:1471 (42:1471  Declaratory...)',
  '42:1981cv': '42:1981cv (42:1981 Civil Rights)',
  '42:1981hs': '42:1981hs (42:1981 Housing Disc...)',
  '42:1981jb': '42:1981jb (42:1981 Job Discrimi...)',
  '42:1981sx': '42:1981sx (42:1981 Sex Discrimi...)',
  '42:1983cv': '42:1983cv (42:1983 Civil Rights...)',
  '42:1983ed': '42:1983ed (42:1983 Civil Rights...)',
  '42:1983pr': '42:1983pr (42:1983 Prisoner Civ...)',
  '42:1986': '42:1986 (42:1986 Neglect of Duty)',
  '42:2000ag': '42:2000ag (42:2000 Job Discrimi...)',
  '42:2000e': '42:2000e (42:2000e  Job Discri...)',
  '42:2000pb': '42:2000pb (42:2000 Job Discrimi...)',
  '42:2000ra': '42:2000ra (42:2000 Job Discrimi...)',
  '42:2000sx': '42:2000sx (42:2000 Job Discrimi...)',
  '42:2003': '42:2003 (42:2003 Job Discrimi...)',
  '42:2005': '42:2005 (42:2005 Review of Ag...)',
  '42:2615': '42:2615 (42:2616 Medical Reco...)',
  '42:2651': '42:2651 (42:2651  Medical Car...)',
  '42:3601': '42:3601 (42:405 Fair Housing Act)',
  '42:4000': '42:4000 (42:4000 National Flo...)',
  '42:4001': '42:4001 (42:4001 National Ins...)',
  '42:4053': '42:4053 (42:4053 Breach of In...)',
  '42:4072': '42:4072 (42:4072 Payment of F...)',
  '42:4321': '42:4321 (42:4321 Review of Ag...)',
  '42:4332': '42:4332 (42:4332 Environmenta...)',
  '42:6901en': '42:6901en (42:6901 Environmenta...)',
  '42:6901rs': '42:6901rs (42:6901 Resource & R...)',
  '42:7413': '42:7413 (42:7413(b)  Clean Ai...)',
  '42:7604cl': '42:7604cl (42:7604 Clear Air Ac...)',
  '42:7604ir': '42:7604ir (42:7604 Petition to ...)',
  '42:9607': '42:9607 (42:9607 Real Propert...)',
  '43:945': '43:945 (43:945  Compensation...)',
  '43:945a': '43:945a (43:945a  Complaint i...)',
  '43:946': '43:946 (43:946  Complaint in...)',
  '45:0051': '45:0051 (45:51 Railways: Fed....)',
  '45:0151': '45:0151 (45:151 Railway Labor...)',
  '45:0184': '45:0184 (45:184 Action to Set...)',
  '45:1395': '45:1395 (45:1395 Railroads: A...)',
  '45:7457': '45:7457 (45:7457 Compel Recla...)',
  '46:0688': '46:0688 (46:688 Jones Act)',
  '46:0741': '46:0741 (46:741 Shipping)',
  '46:0761': '46:0761 (46:761 Shipping: Dam...)',
  '46:1101': '46:1101 (46:1101 Violation of...)',
  '46:1156': '46:1156 (46:1156 Administrati...)',
  '48:0883': '48:0883 (48:883 Violation of ...)',
  '48:1985': '48:1985 (48:1985  Conspiracy/...)',
  '49:0081': '49:0081 (49:81 Damaged Goods ...)',
  '49:0502': '49:0502 (49:502 Motor Carrier...)',
  '49:0781': '49:0781 (49:781 Forfeiture)',
  '49:11503': '49:11503 (49:11503 Railroad Re...)',
  '49:11702': '49:11702 (49:11702(a)(4) Viola...)',
  '49:1471': '49:1471 (49:1471 Federal Avia...)',
  '49:1903': '49:1903 (49:1903  Petition to...)',
  '8:287': '8:287 (8:287 Petition to En...)',
  '99:9999': '99:9999 (99:9999 Report cause...)',
  adsup: 'adsup (Administrative Subpoena)',
  contempt: 'contempt (Contempt Proceedings)',
  disbar: 'disbar (Disbarment Proceedings)',
  fordepo: 'fordepo (Foreign Deposition)',
  misc: 'misc (Civil Miscellaneous ...)',
  motcomp: 'motcomp (Motion to Compel)',
  motquash: 'motquash (Motion to Quash)',
  motret: 'motret (Motion for Return of...)',
  petenf: 'petenf (Petition to Enforce ...)',
  petper: 'petper (Petition to Perpetua...)',
  regjgm: 'regjgm (Registration of Fore...)',
  tranbkref: 'tranbkref (Transmission of Bank...)',
  tranff: 'tranff (Transmission of Prop...)',
  writgar: 'writgar (Application for a Wr...)',
};

const jurisdictionOptions = {
  4: 'Diversity',
  3: 'Federal Question',
  5: 'Local Question',
  2: 'U.S. Government Defendant',
  1: 'U.S. Government Plaintiff',
};

const caseFlagOptions = {
  APPEAL: 'APPEAL',
  ARBITRATION: 'ARBITRATION',
  CASREF: 'CASREF',
  CLOSED: 'CLOSED',
  CONSENT: 'CONSENT',
  ENE: 'ENE',
  HABEAS: 'HABEAS',
  HBS: 'HBS',
  HKS: 'HKS',
  INTERPRETER: 'INTERPRETER',
  JJM: 'JJM',
  JWF: 'JWF',
  LEAD: 'LEAD',
  LGF: 'LGF',
  MEDIATION: 'MEDIATION',
  MEMBER: 'MEMBER',
  MERGED: 'MERGED',
  MOTREF: 'MOTREF',
  MWP: 'MWP',
  PRIOR: 'PRIOR',
  ProSe: 'ProSe',
  SEALED: 'SEALED',
  SETTLE: 'SETTLE',
  SM: 'SM',
  STAT_CLOSE: 'STAT_CLOSE',
  STAYED: 'STAYED',
  VEB: 'VEB',
  VictimNotify: 'VictimNotify',
};

const casePropertiesOptions = {
  open_cases: 'Open Cases',
  closed_cases: 'Closed cases',
};



// WEBPACK FOOTER //
// ./src/pages/filings/SearchCourtRecords/ReportsTab/ReportsTabForms/Civil/Civil.js